
<div class="bl-wrapper">
  <iframe
    class="bl-iframe"
    src="https://app.powerbi.com/reportEmbed?reportId=7fdff369-ead8-44f8-9098-e554f11e58f8&autoAuth=true&ctid=9dfb1a05-5f1d-449a-8960-62abcb479e7d"
    title="Analytics"
    allow="fullscreen"
  ></iframe>
</div>
